import React from 'react';
import HotspotMap from '../HotspotMap';

// "The Range" — annotated hotspot image showing all awning and pergola
// models in one outdoor scene. The HotspotMap component handles the
// per-hotspot interactivity.
export default function ProductMap() {
  return (
    <section className="asg-rangemap" id="range">
      <div className="asg-rangemap-inner">
        <div className="asg-rangemap-header asg-reveal">
          <p className="asg-section-label">The Range</p>
          <h2 className="asg-section-title">Everything we make,<br />in one space.</h2>
          <p className="asg-rangemap-sub">
            Five retractable awnings and three aluminium pergolas.
            Hover any model to highlight, click to view details.
          </p>
        </div>
        <div className="asg-rangemap-image asg-reveal">
          <HotspotMap
            src="/uploads/gallery/12ec6a21cd156b37ca3447cf.webp"
            alt="ASG Shading product overview - all awning and pergola models in one outdoor scene with feature callouts"
          />
        </div>
        <div className="asg-rangemap-cta asg-reveal">
          <a href="#awnings" className="asg-btn-primary">Explore the Range</a>
        </div>
      </div>
    </section>
  );
}
